/**
 * regenerateAuthGate (issue #165)
 *
 * 再生成 (投入 = /fingering への navigate) の前に、Drive 自動保存の再ログインを
 * ユーザに要求すべきかを判定する純関数。副作用・env / storage 参照は持たず、
 * 判定材料の booleans は呼出し側 (Core hook) が解決して渡す契約とする。
 *
 * 背景: 自動保存 ON かつ Drive 構成済のユーザは、投入後に生成物を Drive へ自動保存する。
 * その時点で Drive token が失効していると自動保存が黙って失敗するため、投入前に
 * 再ログインを促す (投入自体をブロックしてモーダルを出す)。
 */
export interface RegenerateAuthGateInput {
  /** 自動保存が有効か (getAutoSaveEnabled)。 */
  autoSaveEnabled: boolean;
  /** Drive 連携が構成済か (Google Client ID などの env が揃っているか)。 */
  isDriveConfigured: boolean;
  /** 有効な Drive token を保持しているか (hasValidDriveToken)。 */
  hasValidToken: boolean;
}

/**
 * 投入前に Drive 再ログインを要求すべきなら true。
 * 自動保存 ON かつ Drive 構成済かつ token 失効の三条件が揃ったときだけ true。
 */
export function needsDriveReauth(input: RegenerateAuthGateInput): boolean {
  return input.autoSaveEnabled && input.isDriveConfigured && !input.hasValidToken;
}
